// removed by extract-text-webpack-plugin
module.exports = {"cursor":"CwImage-cursor"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwimage/CwImage.scss
// module id = 371
// module chunks = 0